// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container .manual .title[data-v-29ad25f0] {\n  text-indent: 0em;\n}\n.app-container .manual .formula[data-v-29ad25f0] {\n  color: #8f8f9d;\n  margin: 0;\n}\n.app-container .manual p[data-v-29ad25f0] {\n  text-indent: 2em;\n  line-height: 18px;\n}", ""]);
// Exports
module.exports = exports;
